// extracted by mini-css-extract-plugin
export default {"firstSection":"Podian_firstSection__w-opO","secondSection":"Podian_secondSection__Jw3nL"};